/**
 *
 * media-config selectors
 *
 */

import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { CONFIG_KEY } from './config-constants';

const selectConfig = (state) => state[CONFIG_KEY] || {};

const makeSelectUserLocationEndpoint = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'videocore.advertising.userLocationApi', 'https://terra.mlb.com'),
    );

// eslint-disable-next-line import/prefer-default-export
export {
    selectConfig,
    makeSelectUserLocationEndpoint,
};
